module.exports = __webpack_public_path__ + "static/img/jiaotongyunshu-3.aefd6a01.svg";